import React, { useEffect, useState } from 'react';
import './Training.css';

export interface KnowledgeBaseSidebarItem {
  id: string;
  label: string;
  onClick: () => void;
  isActive: boolean;
}

export type KnowledgeBaseSidebarSection = 'organizational' | 'profile';

interface KnowledgeBaseSidebarProps {
  activeSection: KnowledgeBaseSidebarSection;
  organizationalItems: KnowledgeBaseSidebarItem[];
  profileItems: KnowledgeBaseSidebarItem[];
}

const KnowledgeBaseSidebar: React.FC<KnowledgeBaseSidebarProps> = ({
  activeSection,
  organizationalItems,
  profileItems
}) => {
  const [openSections, setOpenSections] = useState<Record<KnowledgeBaseSidebarSection, boolean>>({
    organizational: activeSection === 'organizational',
    profile: activeSection === 'profile'
  });

  useEffect(() => {
    setOpenSections({
      organizational: activeSection === 'organizational',
      profile: activeSection === 'profile'
    });
  }, [activeSection]);

  const handleToggle = (section: KnowledgeBaseSidebarSection) => {
    setOpenSections((prev) => {
      const isCurrentlyOpen = prev[section];
      if (isCurrentlyOpen) {
        return {
          ...prev,
          [section]: false
        };
      }
      return {
        organizational: section === 'organizational',
        profile: section === 'profile'
      };
    });
  };

  const renderSection = (
    section: KnowledgeBaseSidebarSection,
    title: string,
    items: KnowledgeBaseSidebarItem[]
  ) => {
    const isActiveSection = activeSection === section;
    const isOpen = openSections[section];
    const hasItems = items.length > 0;

    return (
      <div
        className={`profile-training__sidebar-section${
          isActiveSection ? ' profile-training__sidebar-section--active' : ''
        }`}
      >
        <div
          className="profile-training__sidebar-header"
          onClick={() => handleToggle(section)}
          role="button"
        >
          <span className="profile-training__sidebar-title">{title}</span>
          <span
            className={`profile-training__sidebar-chevron${
              isOpen ? ' profile-training__sidebar-chevron--open' : ''
            }`}
          >
            {isOpen ? '▲' : '▼'}
          </span>
        </div>
        {isOpen && hasItems && (
          <div className="profile-training__sidebar-content">
            {items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`profile-training__sidebar-item${
                  item.isActive ? ' profile-training__sidebar-item--active' : ''
                }`}
                onClick={item.onClick}
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <aside className="profile-training__sidebar">
      {renderSection('organizational', 'Организационное обучение', organizationalItems)}
      {renderSection('profile', 'Профильное обучение', profileItems)}
    </aside>
  );
};

export default KnowledgeBaseSidebar;

